import React, {useContext} from 'react';
import 'styles/settings/Swag.css';
import UniversalEmptyPageHeader from 'components/universal/UniversalEmptyPageHeader';
import {UserContext} from 'components/user/UserContext';

const Swag = () => {
    const {isCashTenant} = useContext(UserContext);

    return (
        <div>
            <UniversalEmptyPageHeader text={''} image={isCashTenant ? 'hearth' : 'flex-hand'}
                                      desktopHeaderScale={isCashTenant ? 0.9 : 1}>
                <div style={{display: 'flex', flexFlow: 'column', alignItems: 'center'}}>
                    <span style={{
                        color: '#4E6C55',
                        fontSize: '20px',
                        fontWeight: 'bold'
                    }}>Silently We Are {isCashTenant ? 'Good' : 'Greedy'}</span>
                    <span style={{
                        color: '#4E6C55',
                        fontSize: '12px'
                    }}>{isCashTenant ? 'Or at least not evil' : 'But tastefully so'}</span>
                </div>
            </UniversalEmptyPageHeader>
            <div style={{display: 'flex', width: '100%'}}>
                <div className="main-content-body-padding">{
                    isCashTenant ? (
                        <>
                            <p>Every cent you pay ends up in the Flextagram app’s pocket.</p>
                            <p>Except for the payment gateway’s cut.</p>
                            <p>And the maintenance costs for this site.</p>
                            <p>And the costs of keeping our charity sister site <a
                                href="https://www.flexagren.com">www.flexagren.com</a> alive.</p>
                        </>
                    ) : (
                        <>
                            <p>We receive no money from this site, every cent you see here comes from people donating
                                to charity and proving it to us.</p>
                            <p>We take no commission on donated money and charge nothing for verifying donations.</p>
                            <p>Our work is funded by our sister site <a
                                href="https://www.flextagram.com">www.flextagram.com</a>, where all flexed money comes
                                from direct payments to us.</p>
                        </>
                    )
                }
                </div>
            </div>
        </div>
    );
};

export default Swag;